export const SET_RANDOM_MESSAGE_LIST = "randommsg/SET_RANDOM_MESSAGE_LIST";
export const DELETE_RANDOM_MESSAGE = "randommsg/DELETE_RANDOM_MESSAGE";
export const INSERT_RANDOM_MESSAGE = "randommsg/INSERT_RANDOM_MESSAGE";
export const UPDATE_RANDOM_MESSAGE = "randommsg/UPDATE_RANDOM_MESSAGE";
export const GET_RANDOM_MESSAGE = "randommsg/GET_RANDOM_MESSAGE";
export const GET_RECIPIENTS_LIST = "randommsg/GET_RECIPIENTS_LIST";